import { useCallback, useState } from "react";

/**
 * Which columns a table hides, remembered per screen.
 *
 * Keyed by screen rather than shared: hiding "Governorate" on the suggestions
 * queue says nothing about whether you want "Seller" on the stores list.
 */
export function useHiddenColumns(
  storageKey: string,
): [ReadonlySet<string>, (key: string) => void] {
  const [hidden, setHidden] = useState<ReadonlySet<string>>(() => {
    try {
      const raw = localStorage.getItem(`admin_cols_${storageKey}`);
      return new Set<string>(raw ? (JSON.parse(raw) as string[]) : []);
    } catch {
      return new Set<string>();
    }
  });

  const toggle = useCallback(
    (key: string) => {
      setHidden((current) => {
        const next = new Set(current);
        if (!next.delete(key)) next.add(key);
        try {
          localStorage.setItem(
            `admin_cols_${storageKey}`,
            JSON.stringify([...next]),
          );
        } catch {
          // A choice that cannot be remembered still applies to this visit.
        }
        return next;
      });
    },
    [storageKey],
  );

  return [hidden, toggle];
}
